import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';

import { PermissionsModule } from '@shure/cloud/shared/permissions/feature-permissions';
import { SearchBarModule, LoaderModule } from '@shure/cloud/shared/ui/components';
import {
	PrismButtonComponent,
	PrismOrgSwitcherComponent,
	PrismTooltipComponent,
	PrismDialogComponent,
	PrismInputComponent,
	PrismListComponent,
	PrismListItemComponent,
	PrismMenuComponent,
	PrismSearchBarComponent,
	PrismMenuItemComponent,
	PrismProfileImageComponent,
	TextValueAccessor,
	PrismIconComponent
} from '@shure/prism-angular-components';

import { SwitchOrganizationService } from './services/switch-organization.service';
import { SwitchOrganizationMainComponent } from './switch-organization-main.component';
import { ChangeOrganizationDialogComponent } from './ui/change-organization-dialog/change-organization-dialog.component';
import { CreateOrganizationDialogComponent } from './ui/create-organization/create-organization-dialog.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		PermissionsModule,
		ReactiveFormsModule,
		TranslocoModule,
		SearchBarModule,
		LoaderModule,
		PrismButtonComponent,
		PrismOrgSwitcherComponent,
		PrismProfileImageComponent,
		PrismTooltipComponent,
		PrismSearchBarComponent,
		PrismListComponent,
		PrismListItemComponent,
		PrismInputComponent,
		PrismMenuComponent,
		PrismMenuItemComponent,
		PrismIconComponent,
		PrismDialogComponent,
		PrismProfileImageComponent,
		TextValueAccessor
	],
	exports: [SwitchOrganizationMainComponent],
	providers: [SwitchOrganizationService],
	declarations: [
		CreateOrganizationDialogComponent,
		SwitchOrganizationMainComponent,
		ChangeOrganizationDialogComponent
	]
})
export class SwitchOrganizationModule {}
